import {Component, OnDestroy, OnInit} from '@angular/core';
import {StatisticheService} from '../../../_services/statistiche.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SaveMessage} from '../../../_helpers/save-message';
import {Subscription} from 'rxjs';
import {QualitaStatisticheStat} from '../../../_models/QualitaStatisticheStat';

@Component({
  selector: 'app-qualita-statistics',
  templateUrl: './qualita-statistics.component.html',
  styleUrls: ['./qualita-statistics.component.scss'],
  standalone: false
})
export class QualitaStatisticsComponent implements OnInit, OnDestroy {
  loading = false;
  startDate: string;
  endDate: string;
  stat: QualitaStatisticheStat;
  subscription: Subscription;

  constructor(
    private statisticheService: StatisticheService,
    private organizzazioniService: OrganizzazioniService,
    private saveMessage: SaveMessage) {}

  get hasData(): boolean {
    return this.stat != null && this.stat.totaleSchede > 0;
  }

  get hasArticoliNc(): boolean {
    return this.stat?.topArticoliNc?.length > 0;
  }

  get hasTipologieNc(): boolean {
    return this.stat?.topTipologieNc?.length > 0;
  }

  ngOnInit() {
    const today = new Date();
    this.startDate = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0).toISOString();
    this.endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59).toISOString();
    this.subscription = this.organizzazioniService.currentOrganizzazione.subscribe(() => this.getStatistics());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getStatistics = () => {
    this.loading = true;
    this.statisticheService
      .getQualitaStatistiche(new Date(this.startDate), new Date(this.endDate), this.organizzazioniService.organizzazioneId)
      .then((result: QualitaStatisticheStat) => this.stat = result)
      .catch(() => this.saveMessage.messageError('Ci sono problemi con il caricamento delle statistiche qualità.'))
      .finally(() => this.loading = false);
  };

  getTipologiaLabel(tipoNc: number): string {
    const labels: Record<number, string> = {
      0: 'Non classificato',
      1: 'Difetto di produzione',
      2: 'Difetto di acquisto',
      3: 'Difetto dimensionale',
      4: 'Difetto estetico',
      5: 'Fuori tolleranza',
    };
    return labels[tipoNc] ?? `Tipo ${tipoNc}`;
  }
}
